import { Component } from '@angular/core';

@Component({
  selector: 'app-equilibria',
  imports: [],
  templateUrl: './equilibria.html',
  styleUrl: './equilibria.scss'
})
export class Equilibria {

}
